import { render, staticRenderFns } from "./NewProject.vue?vue&type=template&id=0d34cec6&scoped=true&"
import script from "./NewProject.vue?vue&type=script&lang=js&"
export * from "./NewProject.vue?vue&type=script&lang=js&"
import style0 from "./NewProject.vue?vue&type=style&index=0&id=0d34cec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34cec6",
  null
  
)

export default component.exports